// extracted by mini-css-extract-plugin
export default {"table":"SoilParametersSection_table__LNjDk"};